// Halftone dot polarity follows the app chrome theme — dark dots on light UI,
// light dots on dark UI. Encoded in the manifest URL hash theme suffix so CDN
// caches light and dark renders independently.

import type { HalftoneImgMode } from '../types';
import type { ManifestThemeName } from './url-hash';

export function halftoneImgModeForTheme(theme: ManifestThemeName): HalftoneImgMode {
  return theme === 'dark' ? 'light' : 'dark';
}
